import React, {useCallback, useRef} from 'react';
import EventListener from 'react-event-listener';

import jQuery from 'jquery';

const PageWrapperNode = document.getElementById('page-wrapper');

const InitialContext = {
    lastTouchStart: null,
    interaction: null,
    firstMove: true,
    fingers: 0,
};

const cancelEvent = event => {
    event.stopPropagation();
    event.preventDefault();
};

const detectDoubleTap = (event, fingers, lastTouchStart) => {
    const now = Date.now();

    if (fingers > 1) return null;

    if (lastTouchStart && now - lastTouchStart < 500) {
        cancelEvent(event);

        /* treat a double tap as a click */
        jQuery(event.target).trigger('click');
    }

    return now;
};

const getInteraction = fingers => fingers === 2 ? 'zoom' : null;

const PreventPageZoom = ({children}) => {
    const context = useRef(InitialContext);

    const handleTouchStart = useCallback(
        event => {
            const fingers = event.touches.length;
            const lastTouchStart = detectDoubleTap(event, fingers, context.current.lastTouchStart);

            context.current = {
                ...context.current,
                lastTouchStart,
                fingers,
            };
        },
        [context],
    );

    const handleTouchMove = useCallback(
        event => {
            const {firstMove, fingers} = context.current;
            let {interaction} = context.current;

            if (firstMove) interaction = getInteraction(fingers);

            if (interaction) cancelEvent(event);

            context.current = {
                ...context.current,
                firstMove: false,
                interaction,
            };
        },
        [context],
    );

    const handleTouchEnd = useCallback(
        event => {
            const fingers = event.touches.length;

            context.current = {
                ...context.current,
                interaction: getInteraction(fingers),
                fingers,
            };
        },
        [context],
    );

    const events = {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
    };

    return (
        <EventListener target={PageWrapperNode} {...events}>
            {children}
        </EventListener>
    );
};

export default PreventPageZoom;
